import { useContext, useEffect, useState } from "react"
import "./LivePreviewStyle.css"
import { UserContext } from '../../../../Utilis';
import { io } from "socket.io-client";
import { API_URL } from "../../../../Api/ServiceAPI";

export default function LivePreview(){
    const [count,setCount]=useState(0)
    const { user } = useContext(UserContext);
    useEffect(() => {

        // Spojimo se i identificirajmo kao primatelj
        const socket = io("https://my.bluedatab.com", {
          query: { email:user.email }
        });
    
        socket.on('new-number', ({ number, from }) => {
            console.log("Get from ",from)
          setCount(number)
        });
    
        return () => socket.disconnect();
      }, []);
    return(
        <div className="live-preview-container">
            <h1>Count: <span>{count}</span></h1>
        </div>
    )
}